import { render, staticRenderFns } from "./EarningsCopy.vue?vue&type=template&id=8851be3a&scoped=true"
import script from "./EarningsCopy.vue?vue&type=script&lang=js"
export * from "./EarningsCopy.vue?vue&type=script&lang=js"
import style0 from "./EarningsCopy.vue?vue&type=style&index=0&id=8851be3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8851be3a",
  null
  
)

export default component.exports